import styled from '@emotion/styled';
import { claudeTokens } from '@/styles/claudeTokens';

/**
 * 모바일 하단 탭바(Header 의 BottomNav) 높이 — 실측 77.5px(safe-area 제외, 390px 폭 기준).
 * 소수점 아래를 버려 액션 바 아래끝이 탭바 뒤로 0.5px 들어가게 둔다. 크게 잡으면 그 사이로 본문이 비쳐 보인다.
 */
export const MOBILE_TAB_BAR_HEIGHT_PX: number = 77;

/**
 * 화면 아래에 붙는 액션 바 — 모바일에서는 하단 탭바 바로 위에 놓인다.
 *
 * 주 동작 버튼(저장, 지원하기 등)을 끝까지 스크롤하지 않아도 누를 수 있게 한다.
 * 자식 버튼의 배치 규칙은 쓰는 쪽에서 `styled(StickyBottomBar)` 로 덧붙인다.
 *
 * `position: fixed` 를 쓰면 안 된다 — 당겨서 새로고침·스와이프 뒤로가기가 `#app-content` 에 transform 을 걸어
 * 고정 자식이 함께 튄다. sticky 는 흐름 안에 자리를 차지하므로 여백용 빈 요소도 필요 없다.
 *
 * 다만 sticky 는 **부모 안에서만** 붙어 있으므로, 페이지 내내 떠 있으려면 페이지 전체를 감싸는 컨테이너의
 * 마지막 자식으로 둬야 한다. 짧은 카드 안에 넣으면 그 카드를 지나는 순간 같이 스크롤돼 사라진다.
 */
export const StickyBottomBar = styled.div`
    position: sticky;
    bottom: 0;
    z-index: 15;
    display: flex;
    gap: 8px;
    margin-top: 24px;
    padding: 12px 0;
    background: ${claudeTokens.color.surface};
    border-top: 1px solid ${claudeTokens.color.border};

    @media (max-width: 768px) {
        /* 하단 탭바 위에 놓는다 — 탭바가 주 동작 버튼을 가리면 안 된다 */
        bottom: calc(${MOBILE_TAB_BAR_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px));
        /* 본문 좌우 여백(#app-content 의 0.5rem)을 상쇄해 화면 폭을 꽉 채운다 */
        margin-left: -0.5rem;
        margin-right: -0.5rem;
        padding: 10px 0.5rem;
    }
`;
